<form
    [formGroup]="settingsForm"
    class="agpr-agentSearchSettings"
>
<ng-container *ngFor="let network of _networks">
        <!-- Twitter -->
        <agpr-panel
            *ngIf="network.type === networkTypes.twitter"
            class="agpr-agentSearchSettings-twitter"
            [header]="network.label"
            [headerIcon]="network.icon"
            [isFormGroup]="true"
            formGroupName="twitter"
        >
            @if(disableSampleRate) {
                <agpr-message
                    class="agpr-agentSearchSettings-twitter-warningMessage"
                    [severity]="messageSeverityEnum.warning"
                >
                    {{ 'Social.agentSearchSettings.twitter.sampleRate.disabled' | localize }}
                </agpr-message>
            }
            <div>
                <div class="agpr-agentSearchSettings-twitter-sampleRate">
                    <agpr-number-input
                        formControlName="sampleRate"
                        [id]="id +'_twitter_sampleRate'"
                        label="Social.agentSearchSettings.twitter.sampleRate"
                        [disabled]="_disabled || disableSampleRate"
                        tooltip="Social.agentSearchSettings.twitter.sampleRate.tooltip"
                        [integerOnly]="true"
                        [min]="1"
                        [max]="100"
                        [defaultValue]="100"
                    ></agpr-number-input>
                </div>

                <div class="agpr-agentSearchSettings-twitter-language">
                    <agpr-include-exclude-chips
                        formControlName="languages"
                        [id]="id +'_twitter_language'"
                        headerLabel="Social.agentSearchSettings.twitter.language"
                        tooltip="Social.agentSearchSettings.twitter.language.tooltip"
                        placeholder="Discover.targeting.searchFieldLabels.search.placeholder"
                        [disabled]="_disabled"
                        [chipValidations]="chipValidations"
                        labelLookupField="name"
                        [autocompleteOptions]="{
                            suggestionsFetcher: localizationService.autocompleteLanguages.bind(localizationService),
                            customOptions: [noContentMessages['languages']]
                        }"
                        [showIncludeAll]="false"
                        (browseAll)="showLanguageBrowser($event)"
                    ></agpr-include-exclude-chips>
                </div>

                <div class="agpr-agentSearchSettings-twitter-verified">
                    <agpr-checkbox
                        formControlName="showVerifiedOptions"
                        [id]="id +'_twitter_showVerifiedOptions'"
                        label="Social.agentSearchSettings.twitter.verified"
                        [disabled]="_disabled"
                        [infoCircleTooltip]="'Social.agentSearchSettings.twitter.verified.tooltip'"
                        [binary]="true"
                    ></agpr-checkbox>
                    <div
                        *ngIf="showVerifiedOptions.value"
                        class="agpr-agentSearchSettings-twitter-verified-radioGroup"
                        role="radiogroup"
                        [attr.aria-label]="'Social.agentSearchSettings.twitter.verified' | localize"
                    >
                        <agpr-radio
                            formControlName="verifiedAuthor"
                            [id]="id +'_twitter_verifiedAuthorOnly'"
                            [disabled]="_disabled"
                            label="Social.agentSearchSettings.twitter.verified.include"
                            [value]="true"
                        ></agpr-radio>
                        <agpr-radio
                            formControlName="verifiedAuthor"
                            [id]="id +'_twitter_excludeVerifiedAuthor'"
                            [disabled]="_disabled"
                            label="Social.agentSearchSettings.twitter.verified.exclude"
                            [value]="false"
                        ></agpr-radio>
                    </div>
                </div>
            </div>

            <div>
                <div class="agpr-agentSearchSettings-twitter-country">
                    <agpr-autocomplete-chips
                        formControlName="countries"
                        [id]="id +'_twitter_country'"
                        header="Social.agentSearchSettings.twitter.country"
                        [disabled]="_disabled"
                        placeholder="Discover.distribution.footer.settings.country.placeholder"
                        [autocompleteOptions]="countryAutocompleteOptions"
                        field="name"
                    ></agpr-autocomplete-chips>
                </div>
                <div
                    class="agpr-agentSearchSettings-twitter-geoCircle"
                    formArrayName="geoCircles"
                >
                    <div class="agpr-agentSearchSettings-twitter-geoCircle-labelContainer">
                        <label class="agpr-agentSearchSettings-twitter-geoCircle-label">
                            <span> {{ 'Social.agentSearchSettings.twitter.geoPicker.label' | localize }} </span>
                            <span
                                role="img"
                                class="agpr-agentSearchSettings-twitter-geoCircle-label-tooltip fa-regular fa-circle-info"
                                [agprTooltip]="radiusTooltip | listTooltip"
                                [escape]="false"
                            ></span>
                        </label>

                        <agpr-button
                            [id]="id + '.geoCircle-addButton'"
                            [style]="buttonTypes.icon"
                            class="agpr-agentSearchSettings-twitter-geoCircle-addButton"
                            icon="fa-regular fa-duotone fa-square-plus"
                            [disabled]="_disabled"
                            (click)="addNewGeoCircle()"
                        ></agpr-button>
                    </div>

                    <div *ngFor="let geoCircle of geoCircles.controls; let index = index" >
                        <ng-container
                            *ngTemplateOutlet="geoCirclePicker; context: {geoCircle: geoCircle, index: index}"
                        ></ng-container>
                    </div>
                </div>
            </div>
        </agpr-panel>
        <agpr-panel
            *ngIf="network.type !== networkTypes.twitter"
            [header]="network.label"
            [headerIcon]="network.icon"
            [collapsed]="true"
        >
            <agpr-message
                [severity]="messageSeverityEnum.noContent"
            >
                <span> {{ 'Social.agentSearchSettings.notAvailable' | localize }} </span>
            </agpr-message>
        </agpr-panel>

</ng-container>
</form>
<!-- GEO CIRLCE PICKER -->
<ng-template #geoCirclePicker let-geoCircle="geoCircle" let-index="index">
    <div [formGroup]="geoCircle" class="agpr-agentSearchSettings-twitter-geoCircle-picker agpr-contextMenu-parent">
        <div class="agpr-agentSearchSettings-twitter-geoCircle-geoCoordinates">
            <agpr-number-input
                formControlName="latitude"
                label="Social.agentSearchSettings.twitter.geoPicker.latitude"
                ariaDescribedBy="geoCoordinates_errors"
                [disabled]="_disabled"
                [showArrows]="false"
                [required]="true"
            ></agpr-number-input>
            <agpr-number-input
                formControlName="longitude"
                label="Social.agentSearchSettings.twitter.geoPicker.longitude"
                ariaDescribedBy="geoCoordinates_errors"
                [disabled]="_disabled"
                [showArrows]="false"
                [required]="true"
            ></agpr-number-input>
        </div>
        <ul
            id="geoCoordinates_errors"
            class="agpr-agentSearchSettings-twitter-geoCircle-geoCoordinates-error"
        >
            <li *ngIf="geoCircle.errors?.['invalidValue']">
                <agpr-form-message>
                    {{ 'Social.agentSearchSettings.twitter.geoPicker.invalidValue'| localize }}
                </agpr-form-message>
            </li>
            <li *ngIf="geoCircle.errors?.['invalidFormat']">
                <agpr-form-message>
                    {{ 'Social.agentSearchSettings.twitter.geoPicker.invalidFormat' | localize }}
                </agpr-form-message>
            </li>
            <li *ngIf="(geoCircle.controls.latitude.dirty && geoCircle.controls.latitude.errors?.['required'])
                || (geoCircle.controls.longitude.dirty && geoCircle.controls.longitude.errors?.['required'])"
            >
                <agpr-form-message>
                    {{ 'Social.agentSearchSettings.twitter.geoPicker.isRequired'| localize }}
                </agpr-form-message>
            </li>

        </ul>

        <ng-container>
            <div class="agpr-agentSearchSettings-twitter-geoCircle-radiusLabelContainer">
                <span>
                    {{ 'Social.agentSearchSettings.twitter.geoPicker.radius' | localize }}
                </span>
                <div
                    class="agpr-agentSearchSettings-twitter-geoCircle-radiusRadioGroup"
                    role="radiogroup"
                >
                    <agpr-radio
                        formControlName="radiusUnit"
                        [disabled]="_disabled"
                        label="km"
                        [value]="geoRadiusUnit.km"
                    ></agpr-radio>
                    <agpr-radio
                        formControlName="radiusUnit"
                        [disabled]="_disabled"
                        label="mi"
                        [value]="geoRadiusUnit.mile"
                    ></agpr-radio>
                </div>

            </div>
            <div class="agpr-agentSearchSettings-twitter-geoCircle-slider">
                <div class="agpr-agentSearchSettings-twitter-geoCircle-sliderContainer">
                    <p-slider
                        formControlName="radius"
                        [step]="minimumRadiusValue"
                        [min]="minimumRadiusValue"
                        [disabled]="_disabled"
                        [max]="geoCircle.value.maximumRadiusValue"
                    ></p-slider>
                    <div class="agpr-agentSearchSettings-twitter-geoCircle-slider-range">
                        <span>
                            {{ minimumRadiusValue }}
                        </span>
                        <span>
                            {{ geoCircle.value.maximumRadiusValue }}
                        </span>
                    </div>
                </div>
                <agpr-number-input
                    formControlName="radius"
                    class="agpr-agentSearchSettings-twitter-geoCircle-slider-input"
                    [min]="minimumRadiusValue"
                    [max]="geoCircle.value.maximumRadiusValue"
                    [disabled]="_disabled"
                    [showArrows]="false"
                ></agpr-number-input>
            </div>
        </ng-container>
        <div class="agpr-contextMenu bottom right">
            <agpr-button
                [style]="buttonTypes.contextMenu"
                icon="fa-regular fa-duotone fa-trash-can "
                tooltip="delete"
                tooltipPosition="top"
                [disabled]="_disabled"
                (click)="deleteGeoCircle(index)"
            ></agpr-button>
        </div>
    </div>
</ng-template>

<ng-template let-item #noMatchingLanguageMessageTemplate>
    <agpr-message
        class="agpr-noContentMessage"
        [severity]="item.severity"
    >
        {{ item.noContentMessageLabel | localize }}
    </agpr-message>
</ng-template>
